import { DetailedRoute } from '@/generated/model/detailedRoute';
import { useCallback, useRef } from 'react';

export function useRouteListScroll() {
  const refs = useRef(new Map<number, HTMLElement>());

  const registerRef = useCallback(
    (route: DetailedRoute | undefined) => (el: HTMLElement | null) => {
      if (!route) return;
      if (el) refs.current.set(route.id, el);
      else refs.current.delete(route.id);
    },
    []
  );

  const scrollTo = useCallback((id: number) => {
    const el = refs.current.get(id);
    el?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return { registerRef, scrollTo };
}
